<template>
    <el-col :md="10" >
        <el-form-item :label="label" v-if="showOn" class="item-fome-base y_axis " :class="classes">
            <div class="text-justify">
                <input :id="id" type="file" @change="uploadFile($event)" class="file-select" />
                <label :for="id" class="file-drag file-upload-btn btn btn-primary label-select" v-html="`選択`"  />
            </div>

            <div v-if="modelPath" style="color:deepskyblue;" class="text-left d-flex align-items-center" >
                <a :href="modelUrl">{{ filename }}</a>
                <i class="el-icon-circle-close el-icon--right ml-2 cursor-pointer" @click="confirmRemoveFile"></i>
            </div>
            <div class="text-left">
                <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
            </div>
        </el-form-item>

        <!-- File removal confirmation modal -->
        <b-modal
            :id="'confirmRemoveFileModal_' + id"
            title="ファイル削除確認" 
            hide-header 
            hide-footer
            size="m"
            centered
            ok-variant="danger"
        >
            <div class="text-center header-modal">
                   <h4>確認</h4> 
                </div>
            <div class="text-center">
                <p class="mb-3">この添付ファイルを削除してもよろしいですか？</p>
            </div>
            <div class="modal-footer text-center" style="justify-content: center ;padding:15px 0px 0px 0px;">
                <b-button class="btn-primary" @click="cancelRemoveFile">
                    {{ $t("NO") }}
                </b-button>
                <b-button class="btn-primary" @click="removeFileItemTable">
                    {{ $t("YES") }}
                </b-button>
            </div>
        </b-modal>
    </el-col>
</template>

<script>
import {
        FORM_ITEM_UPLOAD_FILE
    } from "@/core/services/store/formStore";

export default {
    components: {},

    props: [
        "error",
        "modelPath",
        "modelUrl",
        "label",
        "showOn",
        "modelInput",
        "classes",
        "field",
        "yCoordinate"
    ],
    data() {
        return {
            id: Math.ceil(Math.random()*1000000),
            currentField: null,
            currentYCoordinate: null,
            isLoading: false
        }
    },
    mounted() {
        this.currentField = this.field;
        this.currentYCoordinate = this.yCoordinate;
    },
    computed: {
        queryParam() {
            return this.$route.query;
        },

        filename() {
            if (this.modelPath) {
                let explode = this.modelPath.split("/");
                return explode[explode.length - 1]
            }
        },
    },
    methods: {
        async uploadFile(e, data) {
            this.isLoading = true;
            if (!e.target.files.length)
                return

            let size = this.bytesToSize(e.target.files[0].size);
            // if (size > 350)
            //     this.notifyError('ファイルの容量が最大350MBでアップロードしてください。')

            var files = e.target.files || e.dataTransfer.files;
            const dataPush = new FormData()
            dataPush.append("item_file_path", files[0]);
            dataPush.append("form_id", this.queryParam.form_id);
            const update = await this.$store.dispatch(FORM_ITEM_UPLOAD_FILE, dataPush);

            this.$emit('update:modelPath', update.data.url)
            this.$emit('update:modelUrl', update.data.url_download_file)
            // Reset input file để có thể upload lại cùng file
            e.target.files = null;
            e.target.value = '';
            this.isLoading = false;
        },

        bytesToSize(bytes) {
            let i = 2;
            return Math.round(bytes / Math.pow(1024, i), 2);
        },

        /**
         * start file removal methods
         */
        confirmRemoveFile() {
            this.currentYCoordinate = this.yCoordinate;
            console.log('confirmRemoveFile - component id:', this.id, 'yCoordinate:', this.currentYCoordinate);
            this.$bvModal.show('confirmRemoveFileModal_' + this.id);
        },

        removeFileItemTable() {

            if(!this.field?.item_id || !this.queryParam.form_id || !this.currentYCoordinate) {
                return;
            }
            
            // Emit event to parent with file deletion info
            this.$emit('remove-file', {
                item_id: this.field.item_id,
                form_id: this.queryParam.form_id,
                y_coordinate: this.currentYCoordinate
            });
            
            // Reset input file để có thể upload lại cùng file
            const fileInput = document.getElementById(this.id);
            if (fileInput) {
                fileInput.files = null;
                fileInput.value = '';
            }
            
            this.$bvModal.hide('confirmRemoveFileModal_' + this.id);
        },

        cancelRemoveFile() {
            this.$bvModal.hide('confirmRemoveFileModal_' + this.id);
        },
        /**
         * end file removal methods
         */
    },
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
    cursor: pointer;
}

.el-icon-circle-close{
    cursor: pointer;
    color: #000;
}
.el-icon-circle-close:hover{
    color: red;
}
.header-modal{
    padding-bottom: 30px;
    padding-top: 10px;
}
</style>